import React from 'react'
import '../../css/aboutUs/ourFactory.css'

export default function OurFactory() {
  return (
    <div className="ourFactory" style={{overflow:"hidden"}}>
        <h1 data-aos="zoom-in">OUR FACTORY</h1>
        <img src="assets/about/factory.png" alt="" data-aos="fade-right" />
        <p data-aos="fade-left">With 15000 sq feet modern facility equipped with state of art machinery, we are geared up to international standards with good quality practices to ship you successful merchandise year after year.</p>
    </div>
  )
}
